import t from './Auth.type';

const initlialState = {
  userInfo: null,
  userRole: '',
  isSupplierLoggedIn: false,
  isSupLoggedIn: false,
  isCompanyAdminLoggedIn: false,
  isCompanyUserLoggedIn: false,
  isSupplierUserLoggedIn: false,
  canSuggest: false,
  autoApproved: false,
  securityQuestion: [],
};

const Auth = (state = initlialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case t.SET_CURRENT_USER:
      let canSuggest = false;
      let autoApproved = false;
      if (payload.role === 'Supplier') {
        const companyList = payload.userCompanies.companiesList[0];
        canSuggest = companyList?.canSuggest ? companyList.canSuggest : false;
        autoApproved = companyList?.autoApproved ? companyList.autoApproved : false;
      }
      return {
        ...state,
        userInfo: payload,
        userRole: payload.role,
        isSupplierLoggedIn: payload.role === 'Supplier',
        isSupLoggedIn: payload.role === 'Supplier' && !payload.supplierUserId,
        isCompanyAdminLoggedIn: payload.role === 'Admin',
        isCompanyUserLoggedIn: payload.role === 'User',
        isSupplierUserLoggedIn: !!payload.supplierUserId,
        canSuggest,
        autoApproved,
      };

    case t.FETCH_SECURITY_QUESTIONS:
      return { ...state, securityQuestion: payload };

    case t.VERIFY_OTP:
      return { ...state, verifyOtp: payload };

    default:
      return state;
  }
};

export default Auth;
